/**
* Created by lobin on 2020/6/18.
*/
<template>
  <div class="company">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="公司类型" prop="type">
          <a-radio-group v-model="form.type">
            <a-radio :value="item.value" name="type" v-for="item in companyType" :key="item.value">
              {{ item.name }}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="上级公司" prop="pid" v-if="form.type === '2'">
          <company-search
            v-model="form.pid"
            placeholder="请选上级公司"
          />
        </a-form-model-item>
        <a-form-model-item label="提现用户" prop="bindUser" v-if="form.type === '2' && form.pid">
          <user-search
            v-model="form.bindUser"
            :company="form.pid"
            placeholder="请输入微信昵称查询并选择"
          />
        </a-form-model-item>
        <a-form-model-item ref="bindUserRealName" label="提现人姓名" prop="bindUserRealName" v-if="form.type === '2'">
          <a-input
              v-model="form.bindUserRealName"
              placeholder="请输入公司全称"
          />
        </a-form-model-item>
        <a-form-model-item ref="name" label="公司名称" prop="name">
          <a-input
              v-model="form.name"
              placeholder="请输入公司全称"
          />
        </a-form-model-item>
        <a-form-model-item ref="phone" label="公司电话" prop="phone">
          <a-input
              v-model="form.phone"
              placeholder="请输入公司电话"
          />
        </a-form-model-item>
        <a-form-model-item ref="address" label="公司地址" prop="address">
          <a-input
              v-model="form.address"
              placeholder="请输入公司地址"
          />
        </a-form-model-item>
        <a-form-model-item ref="wechatAppId" label="公众号APPID" prop="wechatAppId">
          <a-input
              :disabled="form.type === '2'"
              v-model="form.wechatAppId"
              placeholder="请输入公众号APPID"
          />
        </a-form-model-item>
        <a-form-model-item ref="wechatSecret" label="公众号秘钥" prop="wechatSecret">
          <a-input
              :disabled="form.type === '2'"
              v-model="form.wechatSecret"
              placeholder="请输入公众号秘钥"
          />
        </a-form-model-item>
        <a-form-model-item label="公众号原生号" prop="mpuser">
          <a-input
            :disabled="form.type === '2'"
            v-model="form.mpuser"
            placeholder="请输入公众号原生号gh_xdj"
          />
        </a-form-model-item>
        <a-form-model-item label="公众验证token" prop="token">
          <a-input
            :disabled="form.type === '2'"
            v-model="form.token"
            placeholder="请输入公众号原生号gh_xdj"
          />
        </a-form-model-item>
        <a-form-model-item label="公众绑定域名" prop="domain">
          <a-input
            :disabled="form.type === '2'"
            v-model="form.domain"
            placeholder="请输入公众号绑定的域名"
          />
        </a-form-model-item>
        <a-form-model-item ref="merchantId" label="微信支付商户ID" prop="merchantId">
          <a-input
              :disabled="form.type === '2'"
              v-model="form.merchantId"
              placeholder="请输入微信支付商户ID"
          />
        </a-form-model-item>
        <a-form-model-item ref="secret" label="微信支付商户秘钥" prop="secret">
          <a-input
              :disabled="form.type === '2'"
              v-model="form.secret"
              placeholder="请输入微信支付商户秘钥"
          />
        </a-form-model-item>
        <a-form-model-item ref="wechatSecretTmpId" label="公众号取件码模板消息ID" prop="wechatSecretTmpId">
          <a-input
              :disabled="form.type === '2'"
              v-model="form.wechatSecretTmpId"
              placeholder="请输入公众号取件码模板消息ID"
          />
        </a-form-model-item>
        <a-form-model-item label="服务方式" prop="provideType">
          <a-radio-group v-model="form.provideType">
            <a-radio :value="item.value" name="type" v-for="item in provideType" :key="item.value">
              {{ item.name }}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="年费费用" prop="annualfee" v-if="form.provideType === '1'">
          <a-radio-group v-model="form.annualfee">
            <a-input prefix="￥" suffix="RMB" v-model="form.annualfee" />
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="单票费用" prop="smsPrice" v-if="form.provideType === '2'">
            <a-input-group compact>
              <a-input placeholder="短信单品费用" prefix="￥" suffix="分" v-model="form.smsPrice" style="width: 50%"/>
              <a-input placeholder="微信单品费用" prefix="￥" suffix="分" v-model="form.wechatPrice" style="width: 50%"/>
            </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input v-model="form.remark" type="textarea" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 8, offset: 8 }">
          <a-button type="primary" @click="onSubmit" :loading="submiting">
            提交
          </a-button>
          <a-button style="margin-left: 10px;" @click="resetForm">
            重置
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script type="text/babel">
import { mapGetters } from 'vuex';
import { creatComapny, companyDetail, companyModify } from '@/api/company';

export default {
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 8 },
      other: '',
      submiting: false,
      type: 'add',
      form: {
        type: '2',
        pid: '',
        name: '',
        phone: '',
        address: '',
        wechatAppId: '',
        wechatSecret: '',
        merchantId: '',
        secret: '',
        bindUser: '',
        bindUserRealName: '',
        provideType: '1',
        annualfee: '',
        priceperunit: '',
        wechatSecretTmpId: '',
        remark: '',
        token: '',
        mpuser: '',
        domain: '',
      },
    };
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    'form.pid'() {
      this.parentCompanyChange();
    },
  },
  created() {
    const { id } = this.$route.params;
    const { type } = this.$route.meta;
    this.type = type;
    this.id = id;
    if (id && type === 'modify') {
      this.getDetail();
    }
  },
  computed: {
    ...mapGetters(['provideType', 'companyType']),
    rules() {
      const com = {
        type: [
          { required: true, message: '选择公司类型', trigger: 'change' },
        ],
        name: [
          { required: true, message: '请输入公司全称', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入公司电话', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入公司地址', trigger: 'blur' },
        ],
        wechatAppId: [
          { required: true, message: '请输入公司微信公众号APPID', trigger: 'blur' },
        ],
        wechatSecret: [
          { required: true, message: '请输入公司微信公众号秘钥', trigger: 'blur' },
        ],
        token: [
          { required: true, message: '请输入验证秘钥', trigger: 'blur' },
        ],
        mpuser: [
          { required: true, message: '请输入公众号原始号', trigger: 'blur' },
        ],
        domain: [
          { required: true, message: '请输入公众号绑定的域名', trigger: 'blur' },
        ],
        merchantId: [
          { required: true, message: '请输入公司微信支付商户号', trigger: 'blur' },
        ],
        secret: [
          { required: true, message: '请输入公司微信支付商户秘钥', trigger: 'blur' },
        ],
        provideType: [
          { required: true, message: '请选择收费方式', trigger: 'change' },
        ],
        annualfee: [
          { required: this.form.provideType === '1', message: '请输入年费', trigger: 'blur' },
        ],
        wechatSecretTmpId: [
          { required: true, message: '取件码模板消息ID', trigger: 'blur' },
        ],
        priceperunit: [
          { required: this.form.provideType === '2', message: '请输入单票价格', trigger: 'blur' },
        ],
      };
      const othrules = {
        ...com,
        bindUser: [
          { required: true, message: '请选择提现的用户', trigger: 'change' },
        ],
        bindUserRealName: [
          { required: true, message: '请选择提现用户的真是名字', trigger: 'change' },
        ],
        pid: [
          { required: true, message: '选择上级公司', trigger: 'blur' },
        ],
      };
      return this.form.type === '2' ? othrules : com;
    },
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.sumbitData();
          return true;
        }
        return false;
      });
    },
    async sumbitData() {
      this.submiting = true;
      const message = '提交成功';
      let res;
      if (this.type === 'modify') {
        res = await companyModify(this.id, this.form);
      } else {
        res = await creatComapny(this.form);
      }
      if (res.code === 0) {
        this.$message.success(message);
        this.resetForm();
      }
      this.submiting = false;
    },
    async getDetail() {
      const { data } = await companyDetail(this.id);
      this.form = data;
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    async parentCompanyChange() {
      const { data } = await companyDetail(this.form.pid);
      this.form.wechatAppId = data.wechatAppId;
      this.form.wechatSecret = data.wechatSecret;
      this.form.token = data.token;
      this.form.mpuser = data.mpuser;
      this.form.domain = data.domain;
      this.form.merchantId = data.merchantId;
      this.form.secret = data.secret;
      this.form.wechatSecretTmpId = data.wechatSecretTmpId;
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.company {
}
</style>
